import { commonFetch, fetch } from "./fetch";

/** 服务中心 */
// 获取公告列表
export function findByNoticeCustomerPageDto(
  data: NoticeListParams
): Promise<NoticeList> {
  return commonFetch(
    "/crm-dms/v1/notice/notice/findByNoticeCustomerPageDto",
    true,
    data
  );
}

// 公告详情
export function getNoticeDetail(data: { id: string }): Promise<NoticeDetail> {
  return commonFetch("/crm-dms/v1/notice/notice/findById", true, data);
}

// 公告标记已读
export function NoticeReadRecord(
  data: NoticeReadRecordParams
): Promise<NoticeReadRecordParams> {
  return commonFetch(
    "/crm-dms/v1/noticeReadRecord/noticeReadRecord",
    false,
    data
  );
}

// 订单数量
export function findNumberByConditions(
  data: FindNumberByConditionsParams
): Promise<number> {
  return commonFetch(
    "/crm-dms/v1/order/yingde/findNumberByConditions",
    true,
    data
  );
}
// 对账函数量
export function findNoReaderByCustomerUser(
  data: FindNoReaderByCustomerUserParams
): Promise<number> {
  return commonFetch(
    "/crm-dms/v1/reconciliationHeader/reconciliationHeader/findNoReaderByCustomerUser",
    true,
    data
  );
}
// 发票管理
export function invoice_findByConditions(
  data: InvoiceFindByConditionsParams
): Promise<InvoiceFindByConditions> {
  return commonFetch(
    "/crm-dms/v1/goldenTaxInvoice/findByConditions",
    true,
    data
  );
}

/** 我的订单 */
export function getOrderFindByConditions(
  data: OrderFindByConditionsParams
): Promise<OrderFindByConditions> {
  return commonFetch("/crm-dms/v1/order/yingde/findByConditions", true, data);
}

/** 订单详情 */
export function getOrderDetail(data: { id: string }): Promise<OrderDetails> {
  return commonFetch("/crm-dms/v1/order/yingde/findById", true, data);
}

// 获取发货信息数据
export function findListByCrmOrderNo2(data: {
  crmOrderNo: string;
}): Promise<DeliveryDetailItems[]> {
  return commonFetch(
    "/crm-dms/v1/order/logistics/findListByCrmOrderNo2",
    true,
    data
  );
}

// 获取物流信息
export function getDeliveryOrderInfo(data: {
  deliveryOrderNo: string;
  crmOrderNo: string;
}): Promise<DeliveryOrderInfo> {
  return fetch({
    url: "/crm-dms/v1/order/logistics/getDeliveryOrderInfo",
    method: "post",
    data,
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
  });
}

// 质检报告
export function getInspectionInfo(data: {
  orderno?: string;
  ztype: string;
  prueflos?: string;
}): Promise<any> {
  return fetch({
    url: "/crm-dms/v1/order/invoice/QMI008",
    method: "post",
    data,
  });
}

// 质检报告pdf id获取
export function getFileByConditions(data: {
  vbelnVl: string;
  zType?: string;
  id?: string;
}): Promise<{ records: FileInfo[] }> {
  return commonFetch(
    "/crm-dms/v1/order/invoice/findPdfByConditions",
    true,
    data
  );
}

/** 我的余额 */
// 查询销售视图
export function findByUserCode(data: {
  userCode: string;
}): Promise<FindByUserCode> {
  return commonFetch(
    "/crm-mdm/v1/customerUser/customerUser/findByUserCode",
    true,
    data
  );
}

// 查询授信获取信用段
export function customerSales(data: SalesView[]): Promise<CustomerSalesItem[]> {
  return commonFetch(
    "/crm-dms/v1/credit/auth/credit/feign/area/customerSales",
    false,
    data
  );
}

// 查询余额
export function accountBalance(
  data: AccountBalanceParams
): Promise<AccountBalance> {
  return commonFetch("/crm-bridge/v1/push/sap/accountBalance", false, data);
}

// 获取应付明细列表
export function balance_findByConditions(
  data: BalFindByConditionsParams
): Promise<BalFindByConditions> {
  return commonFetch(
    "/crm-dms/v1/goldenTaxInvoice/findByConditions",
    true,
    data
  );
}

// 获取付款明细列表
export function balance_findAllByPage(
  data: BalFindAllByPageParams
): Promise<BalFindAllByPage> {
  return commonFetch("/crm-dms/v1/paymentInfo/findAllByPage", true, data);
}

/** 对账函 */
// 获取对账函列表
export function reconcile_findByConditions(
  data: RecFindByConditionsParams
): Promise<RecFindByConditions> {
  return commonFetch(
    "/crm-dms/v1/reconciliationHeader/reconciliationHeader/findByConditions",
    true,
    data
  );
}

// 通过id获取对账函详情
export function reconcile_findById(data: {
  id: string;
  type: string;
}): Promise<RecfindById> {
  return commonFetch(
    "/crm-dms/v1/reconciliationHeader/reconciliationHeader/findById",
    true,
    data
  );
}

/** 我的发票 */
// 发票设置为已读
export function invoice_setRead(id: string): Promise<unknown> {
  return commonFetch(`/crm-dms/v1/goldenTaxInvoice/${id}?read=1`, true);
}

/** 修改密码 */
export function updatePasswordInLoginStatus(data: {
  originalPassword: string;
  newPassword: string;
  confirmPassword: string;
}): Promise<RecfindById> {
  return commonFetch(
    "/crm-ems/v1/mallUser/mallUser/updatePasswordInLoginStatus",
    false,
    data
  );
}

/** 液位管理 */
export function findTTsByCustomerUserCode(data: {
  customerUserCode: string;
}): Promise<TTsInfo[]> {
  return commonFetch(
    "/crm-mdm/v1/tank/tank/findTTsByCustomerUserCode",
    true,
    data
  );
}

const serviceApi = {
  findByNoticeCustomerPageDto,
  getNoticeDetail,
  NoticeReadRecord,
  findNumberByConditions,
  findNoReaderByCustomerUser,
  invoice_findByConditions,
  getOrderFindByConditions,
  getOrderDetail,
  findListByCrmOrderNo2,
  getDeliveryOrderInfo,
  getInspectionInfo,
  getFileByConditions,
  findByUserCode,
  customerSales,
  accountBalance,
  balance_findByConditions,
  balance_findAllByPage,
  reconcile_findByConditions,
  reconcile_findById,
  invoice_setRead,
  updatePasswordInLoginStatus,
  findTTsByCustomerUserCode,
};

export default serviceApi;
